import { cn } from "../../utils/tailwind-class-merge.js";

interface FancySpinnerProps {
  size?: "small" | "medium" | "large";
}

export const FancySpinner = ({ size = "medium" }: FancySpinnerProps) => {
  const sizeClass = () => {
    switch (size) {
      case "small": {
        return "size-6";
      }
      case "large": {
        return "size-20";
      }

      // case "medium":
      default: {
        return "size-12";
      }
    }
  };

  return (
    <div
      className={cn(
        "mx-auto animate-spin rounded-full border-b-2 border-gray-900",
        sizeClass()
      )}
    />
  );
};
